import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { Store } from '../../../../../services/store';
import { toVoid } from '../../../../../utils/void';
import { WhereUsedProvider } from './where-used.provider';
import { WhereUsedItemDto } from './where-used-item.dto';

export interface WhereUsedState {
  loading: boolean;
  items: WhereUsedItemDto[] | undefined;
}

const INITIAL_STATE: WhereUsedState = {
  loading: false,
  items: undefined
};

@Injectable({ providedIn: 'root' })
export class WhereUsedStore extends Store<WhereUsedState> {
  constructor(private provider: WhereUsedProvider) {
    super(INITIAL_STATE);
  }

  init(bomItemId: number | undefined): Observable<void> {
    if (bomItemId === undefined) {
      // item not saved in backend yet (/bom/new) — nothing can use it
      this.update(state => ({ ...state, loading: false, items: [] }));
      return of(undefined);
    }

    this.update(state => ({ ...state, loading: true }));

    return this.provider.getWhereUsed(bomItemId)
      .pipe(
        tap(items => {
          this.update(state => ({
            ...state,
            loading: false,
            items
          }));
        }),
        toVoid()
      );
  }
}
